<template>
    <div id="app">
        <el-container>
            <el-header style="height: 48px" :class="XiaoTuan?'el-header-xiaotuanbac':'el-header-bac'">
                <Header/>
            </el-header>
            <el-container v-if="loaduserinfo">
                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    import Header from './Header'
    import {getUserByToken,timingDevice,isXiaoTuan} from '@/api/login'
    export default {
        name: 'Index',
        data() {
          return {
            XiaoTuan:false,
            loaduserinfo: false,

          }
        },
        beforeCreate() {
            var appguid = this.$route.query.appguid;
            if (appguid) {
                localStorage.setItem("appguid", appguid);
            }
            var token = this.$route.query.token;
            var tenantid=  this.$route.query.tenantid;
            if(tenantid){
                localStorage.setItem("tenantid", tenantid);
            }
            //由其他应用跳转过来，根据token获取其他信息
            if (appguid && token) {
                localStorage.setItem("hpapi_token", token);
                getUserByToken({token: token}).then(response => {
                    //加载完用户信息，显示iframe内容
                    this.loaduserinfo=true;
                    localStorage.setItem("hpapi_tokenModel", JSON.stringify(response.data.tokenModel));
                    localStorage.setItem("hpapi_userInfoModel", JSON.stringify(response.data.userInfoModel));
                    var loginApp = response.data.tokenModel.tenantDO.filter(element => {
                        return element.appguid == appguid && element.unitguid == response.data.userInfoModel.tenantid;
                    });
                    //设置标题
                    if (loginApp.length) {
                        document.title = loginApp[0].tenantname + "【" + loginApp[0].appname + "】";
                    }
                });
            }
            else {
                this.loaduserinfo=true;
            }
        },
        mounted() {
          this.XiaoTuan=isXiaoTuan();
          if (localStorage.getItem("hpapi_tokenModel")) {
            this.loaduserinfo = true;
          }
          var userinfo = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
          var tokenInfo = JSON.parse(localStorage.getItem("hpapi_tokenModel"));
          for (var i = 0; i < tokenInfo.tenantDO.length; i++) {
            if (tokenInfo.tenantDO[i].unitguid == userinfo.tenantid && tokenInfo.tenantDO[i].ifusemember == -1) {
              localStorage.removeItem("appguid");
              localStorage.removeItem("tenantid");
              localStorage.removeItem("hpapi_token");
              localStorage.removeItem("hpapi_tokenModel");
              localStorage.removeItem("hpapi_userInfoModel");
              this.$message.error('系统尚未正式启用，请先初始化数据!')
              this.$router.push("/login");
              return;
            }
          }

          //定时执行代码
          timingDevice();
        },
        components: {
            "Header": Header
        }
    }
</script>

<style scoped>

    .el-main {
        padding: 0px;
        height: calc(100vh - 48px);
        /*background-color: red;*/
        width: 100%;
        overflow: auto;
    }

    .el-header {
        min-width: 1300px;
        padding: 0px;
        height: 48px;
        background-size: cover;
        margin: 0px;
    }

    .el-header-bac {
      background-image: url(../../assets/images/head-bac.jpg);
    }

    .el-header-xiaotuanbac {
      background-image: url(../../assets/images/head-xiaotuanbac.png);
    }
</style>



// WEBPACK FOOTER //
// src/components/index/Index.vue